import { makeStyles } from 'tss-react/mui';

export const useOrderTableStyles = makeStyles()(theme => {
  return {
    img: {
      width: '50px',
      maxHeight: 65,
      cursor: 'pointer',
      borderRadius: 4,
      [theme.breakpoints.down('sm')]: {
        maxHeight: 80,
      },
    },
    colorButtonIconView: {
      minWidth: 0,
      padding: 5,
    },
    card: {
      width: '97%',
      paddingLeft: 0,
      marginTop: 6,
      marginBottom: 0,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
      background: theme.palette.grey[100],
    },
    cardFooter: {
      width: '97%',
      paddingLeft: 0,
      marginTop: 0,
      marginBottom: 16,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
      background: theme.palette.grey[100],
    },
    tableWrapper: {
      width: '97%',
      overflowX: 'auto',
      marginTop: 6,
      marginBottom: 0,
      // borderRadius: 4,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
     itemsTable: {
       width: '100%',
       borderCollapse: 'collapse',
       tableLayout: 'fixed' as const,
       border: '1px solid #fff',
     },
     tableHeaderRow: {
       backgroundColor: theme.palette.grey[100],
     },
    tableRow: {
      '&:nth-of-type(even)': {
        backgroundColor: '#fafafa',
      },
    },
    thImg: {
      // width: 120,
      padding: '10px 10px',
      textAlign: 'left' as const,
      fontWeight: 700,
      fontSize: 14,
      color: '#333333',
       border: '1px solid #fff',
     },
     thName: {
       padding: '10px 10px',
       textAlign: 'left' as const,
       fontWeight: 700,
       fontSize: 14,
       color: '#333333',
       border: '1px solid #fff',
     },
     thPrice: {
       // width: 130,
       padding: '10px 10px',
       textAlign: 'left' as const,
       fontWeight: 700,
       fontSize: 14,
       color: '#333333',
       border: '1px solid #fff',
     },
     thCount: {
       // width: 120,
       padding: '10px 10px',
       textAlign: 'center' as const,
       fontWeight: 700,
       fontSize: 14,
       color: '#333333',
       border: '1px solid #fff',
     },
     thSum: {
       // width: 130,
       padding: '10px 10px',
       textAlign: 'right' as const,
       fontWeight: 700,
       fontSize: 14,
       color: '#333333',
       border: '1px solid #fff',
     },
     tdImg: {
       padding: '10px 10px',
       verticalAlign: 'middle' as const,
       border: '1px solid #fff',
     },
     tdName: {
       padding: '10px 10px',
       verticalAlign: 'middle' as const,
       wordBreak: 'break-word' as const,
       border: '1px solid #fff',
     },
     tdPrice: {
       padding: '10px 10px',
       verticalAlign: 'middle' as const,
       fontSize: 14,
       color: '#000000',
       border: '1px solid #fff',
     },
     tdCount: {
       padding: '10px 10px',
       verticalAlign: 'middle' as const,
       textAlign: 'center' as const,
       fontSize: 14,
       color: '#000000',
       border: '1px solid #fff',
     },
     tdSum: {
       padding: '10px 10px',
       verticalAlign: 'middle' as const,
       textAlign: 'right' as const,
       fontSize: 14,
       color: '#000000',
       fontWeight: 600,
       border: '1px solid #fff',
     },
    link: {
      marginRight: theme.spacing(3),
      fontSize: 16,
      color: '#000000',
      fontWeight: 'normal',
    },
    typeList: {
      backgroundColor: 'white',
      maxWidth: 200,
    },
    contentWrapper: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    infoWrapper: {
      marginLeft: 20,
      width: '100%',
    },
    infoButtonsWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'start',
    },
    tableContainer: {
      paddingRight: theme.spacing(2),
      paddingLeft: 20,
      paddingTop: 25,
      overflowX: 'auto',
      width: '100%',
    },
    containerLink: {
      width: 250,
      overflow: 'hidden',
    },
    productPrice: {
      color: '#000000',
      fontSize: 21,
      height: 30,
      fontWeight: 'normal',
    },
    titlePriceOnce: {
      color: '#000000',
      fontSize: 15,
      height: 20,
      fontWeight: 'normal',
    },
    containerCount: {
      paddingLeft: 10,
      paddingRight: 10,
    },
    count: {
      color: '#000000',
      fontSize: 20,
      height: 24,
      fontWeight: 'normal',
      paddingTop: 3,
    },
    containerSum: {
      width: 200,
    },
    sum: {
      color: '#000000',
      fontSize: 21,
      height: 30,
      fontWeight: 'normal',
    },
    titleSum: {
      color: '#000000',
      fontSize: 15,
      height: 32,
      fontWeight: 'normal',
    },
    containerSumVendor: {
      paddingLeft: 20,
      paddingTop: 20,
      paddingBottom: 20,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    wrapperSumVendor: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    titleVendorSum: {
      color: '#757575',
      fontSize: 21,
      height: 27,
      fontWeight: 'normal',
    },
    vendorSum: {
      color: '#000000',
      fontSize: 21,
      height: 27,
      fontWeight: 'normal',
      marginLeft: 10,
    },
    paymentStatus: {
      color: '#205373',
      fontSize: 21,
      height: 27,
      fontWeight: 'normal',
      marginLeft: 10,
    },
    requisites: {
      fontSize: 20,
      color: '#ffffff',
      fontWeight: 'normal',
    },
  };
});
